import "./candidateslist.scss";
import { inject, observer } from "mobx-react";
import topArrow from "images/topArrow.svg";
import downArrow from "images/downArrow.svg";
import plus from "images/plus.svg";
import ApplicationSuccessModalFromVacancy from "../ApplicationSuccessModalFromVacancy/index";
import EducationalCenter from "../EducationalCenter/index";
import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";

const CandidatesList = ({
  id,
  positionId,
  vacancyId,

  candidatesForVacancy,
  getCandidatesForVacancy,

  educationalCenterModal,
  applicationSuccessModalFromVacancy,
  setEducationalCenterModal,
  setApplicationSuccessModalFromVacancy,
  cleanErrorAddition,
  cleanErrorWithoutDate,
  setIsCandidateModalOpen,
  setIsNewCandidate,
  setSelectedCandidate,

  clearOneCandidate,
  isLoading
}) => {
  const [openList, setOpenList] = useState(false);

  let addCheckedInCandidate = () => {
    getCandidatesForVacancy({
      on_page: 10000,
      page: 1,
      vacancy: id
    });
    for (let i = 0; i < candidatesForVacancy.length; ++i) {
      candidatesForVacancy[i]["checked"] = false;
    }
  };

  useEffect(() => {
    openList && addCheckedInCandidate();
  }, [openList]);

  const disabled = candidatesForVacancy.some(
    (candidate) => candidate["checked"]
  );

  return (
    <>
      <div className="candidateslist">
        {/* Вознаграждение скрыто в задаче FRONT-843 */}
        {/* <div className="candidateslist__text__bigcols1">
          <p className="candidateslist__text-small">Ваше вознаграждение за одного подтверждённого кандидата:</p>
          <p className={`candidateslist__text-agentSalary ${hot === "1" ? "hotvacancy__color-text" : "normalvacancy__color-text"}`}>
            {agentsalary} руб
          </p>
        </div> */}
        <div className="candidateslist__alllist">
          <div className="candidateslist__text__cols2 flex-column gap-2">
            <div className="d-flex justify-content-between w-100">
              <p
                className="candidateslist__text-title"
                onClick={() => setOpenList(!openList)}
              >
                Выберите кандидатов для отклика
              </p>
              <p className="candidateslist__text-img">
                <img
                  src={openList ? topArrow : downArrow}
                  onClick={() => setOpenList(!openList)}
                  alt=""
                />
              </p>
            </div>
            {/* Вознаграждение скрыто в задаче FRONT-843 */}
            {/* <div className="candidateslist__text__smallcols1">
              <p className="candidateslist__text-small">
                Ваше вознаграждение за одного подтверждённого кандидата:{" "}
                <span
                  className={`candidateslist__text-agentSalary ${
                    hot === "1"
                      ? "hotvacancy__color-text"
                      : "normalvacancy__color-text"
                  }`}
                >
                  {agentsalary}
                </span>
              </p>
            </div> */}
          </div>
          {openList && (
            <>
              <div
                className="candidateslist__list-items-addition"
                onClick={() => {
                  clearOneCandidate();
                  setSelectedCandidate("");
                  setIsNewCandidate(true);
                  cleanErrorAddition();
                  setIsCandidateModalOpen(true);
                }}
              >
                <img src={plus} alt="" />
                <p className="candidateslist__list-items-addition-text">
                  Добавить кандидата
                </p>
              </div>
              <div className="candidateslist__list-items">
                <div className="candidateslist__list-items-top">
                  {isLoading ? (
                    <p className="candidateslist__list-items-text">
                      Пожалуйста, подождите
                    </p>
                  ) : candidatesForVacancy.length > 0 ? (
                    candidatesForVacancy.map((candidate) => {
                      return (
                        <div
                          key={candidate.id}
                          className="candidateslist__list-items-check"
                        >
                          <Form.Check
                            className="candidateslist__list-items-checkbox"
                            id={candidate.id}
                            name="scales"
                            onChange={(e) => {
                              e.target.checked
                                ? (candidate["checked"] = true)
                                : (candidate["checked"] = false);
                            }}
                          />
                          <label
                            htmlFor={candidate.id}
                            className="candidateslist__list-items-text"
                          >
                            {candidate.surname} {candidate.name}{" "}
                            {candidate.patronymic}
                          </label>
                        </div>
                      );
                    })
                  ) : (
                    <p className="candidateslist__list-items-text">
                      Вы не добавили ни одного кандидата или администратор еще
                      не подтвердил его данные
                    </p>
                  )}
                </div>
              </div>

              <button
                className="candidateslist-btn"
                onClick={() => {
                  setEducationalCenterModal(true);
                }}
                disabled={!disabled}
              >
                Выбрать
              </button>
            </>
          )}
        </div>
      </div>
      <EducationalCenter
        show={educationalCenterModal}
        onHide={() => setEducationalCenterModal(false)}
        setEducationalCenterModal={setEducationalCenterModal}
        positionId={positionId}
        candidates={candidatesForVacancy}
        setOpenList={setOpenList}
        setSuccessModal={setApplicationSuccessModalFromVacancy}
        vacancyId={vacancyId}
      />
      <ApplicationSuccessModalFromVacancy
        show={applicationSuccessModalFromVacancy}
        onHide={() => {
          setApplicationSuccessModalFromVacancy(false);
          cleanErrorWithoutDate("");
        }}
        setSuccessModal={setApplicationSuccessModalFromVacancy}
      />
    </>
  );
};

export default inject(({ candidatesStore, modalWindows }) => {
  const {
    candidatesForVacancy,
    applications,
    applicationsStatuses,
    getCandidatesForVacancy,

    cleanErrorAddition,
    cleanErrorWithoutDate,
    setIsNewCandidate,
    setSelectedCandidate,

    clearOneCandidate,
    isLoading
  } = candidatesStore;

  const {
    educationalCenterModal,
    applicationSuccessModalFromVacancy,
    setApplicationSuccessModalFromVacancy,
    setEducationalCenterModal,
    setApplicationSuccessModal,
    setIsCandidateModalOpen
  } = modalWindows;

  return {
    candidatesForVacancy,

    applications,
    applicationsStatuses,
    getCandidatesForVacancy,

    educationalCenterModal,
    applicationSuccessModalFromVacancy,
    setApplicationSuccessModalFromVacancy,
    setEducationalCenterModal,
    setApplicationSuccessModal,
    cleanErrorAddition,
    cleanErrorWithoutDate,
    setIsCandidateModalOpen,
    setIsNewCandidate,
    setSelectedCandidate,

    clearOneCandidate,
    isLoading
  };
})(observer(CandidatesList));
